import Button from 'react-bootstrap/esm/Button';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import { Link } from 'react-router-dom';
import ListGoals from './ListGoals';

const RouteGoals = () => {
  return (
    <>
      <Row className="justify-content-end">
        <Col sm="auto">
          <Link to="/goal/create">
            <Button>Create</Button>
          </Link>
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <ListGoals />
        </Col>
      </Row>
    </>
  );
};

export default RouteGoals;
